import { useTranslation } from 'react-i18next';
import SuccessScreen from '@/components/ui/SuccessScreen/SuccessScreen';

interface OpenFundSuccessScreenProps {
  onClose: () => void;
}

const OpenFundSuccessScreen = ({ onClose }: OpenFundSuccessScreenProps) => {
  const { t } = useTranslation();

  return (
    <SuccessScreen
      title={t('openFundRequest.success.title')}
      description={t('openFundRequest.success.description')}
      primaryButtonText={t('openFundRequest.success.closeButton')}
      primaryButtonAction={onClose}
    />
  );
};

export default OpenFundSuccessScreen;
